module.exports = __webpack_public_path__ + "static/media/CBR-product-img@2x.591e55b3.png";